































































import { Component, Prop, Watch, Vue } from "vue-property-decorator";
import MainPageCategory from "@/components/articles/MainPageCategory.vue";
import Form from "@/components/pages/home/Form.vue";
import api from "@/api/index.ts";
import { mapGetters } from "vuex";
import {setMeta} from "@/setMeta";

@Component({
  name: "TopArticles",
  components: {
    MainPageCategory,
    Form
  },
  computed: {
    ...mapGetters("app", ["isFontLoad", "isLangDetected", "lang"])
  }
})
export default class TopArticles extends Vue {
  categories: any[] = [];
  noCatArticles: boolean = false;

  async mounted() {
    const categoriesData = (await api.getArticles()).data.data;
    this.categories = categoriesData.filter(category => {
      return category.articles.length > 0;
    });
    if (!this.categories.length) this.noCatArticles = true;

  }

  @Watch("lang")
  async onLangChanged() {
    this.categories = [];
    this.noCatArticles = false;
    await this.fetchData();
    setTimeout(() => {
      this.$forceUpdate();

    }, 500);
  }

  async fetchData() {
    const categoriesData = (await api.getArticles()).data.data;

    this.categories = categoriesData.filter(category => {
      return category.articles.length > 0;
    });
    if (!this.categories.length) {
      this.noCatArticles = true;
    } else {
      this.noCatArticles = false;
    }
  }
}
